import { ORPCError } from "@orpc/client";

export function isNotFoundError(error: unknown): boolean {
    return error instanceof ORPCError && error.code === "NOT_FOUND";
}

export function isForbiddenError(error: unknown): boolean {
    return error instanceof ORPCError && error.code === "FORBIDDEN";
}
